<template>
  <div class=" flex-r-center">
    <div class="card-width">
      <el-card>
        <div slot="header" class="card-wrap flex-center-center fz24">
          <div
              class="tab-item"
              :class="activeName == 'company' ? 'tab-item-active' : 'tab-item-inactive'"
              @click="onClickTab('company')"
          >
            单位公章申领
          </div>
<!--          <div-->
<!--              class="tab-item"-->
<!--              :class="activeName == 'single' ? 'tab-item-active' : 'tab-item-inactive'"-->
<!--              @click="onClickTab('single')"-->
<!--          >-->
<!--            个人私章申领-->
<!--          </div>-->
        </div>
        <single-apply v-if="activeName == 'single'"></single-apply>
        <official-apply v-if="activeName == 'company'"></official-apply>
      </el-card>
    </div>
  </div>
</template>
<script>
import SingleApply from "./SingleApply.vue";
import OfficialApply from "./OfficialApply.vue";
export default {
  components: {
    SingleApply,
    OfficialApply,
  },
  data() {
    return {
      activeName: "company",
    };
  },
  methods: {
    onClickTab(flag) {
      this.activeName = flag;
    },
  },
};
</script>
<style lang="less" scoped>
.apply-area {
  height: calc(100vh - 104px);
  padding: 20px 30px;
  min-height: 778px;
  background: #f5f7fa;
}
.tab-item {
  position: relative;
  margin: 0 45px;
  cursor: pointer;
}
.tab-item-active {
  color: #407fff;
  &:after {
    position: absolute;
    content: "";
    width: 32px;
    height: 2px;
    background-color: #407fff;
    left: 50%;
    bottom: -19px;
    margin-left: -16px;
  }
}
.tab-item-inactive {
  color: #999;
}
::v-deep .el-card {
  width: 1200px;
  height: 730px;
}
::v-deep .el-card__header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
::v-deep .el-card__body {
  padding: 20px 0;
}
</style>
